import React, { useState } from "react";
export default function RestartChat({ GAEvent, restartChat, setModelStatus, isService }) {
  const handleRestart = () => {
    GAEvent({ eventAction: "Restart-Chat", eventLabel: "Chat-Restart" })
    setModelStatus(false)
    restartChat();
  }
  return (
    <div className="user-actions">
      {isService ?
        null :
        <button className="feedbackButton" onClick={handleRestart}>
          Restart Chat
        </button>
      }

    </div>
  );
}
